import React, { FunctionComponent } from 'react';
import { Action } from 'redux';
import { connect, DispatchProp } from 'react-redux';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { alignSelectedItems } from '../../modules/annotations/paperActions';

type Props = DispatchProp<Action>;

const HorizontallyAlign: FunctionComponent<Props> = ({ dispatch }) => (
  <Tooltip disableInteractive disableFocusListener id="remove-page-tooltip" title="Horizontally Align">
    <div>
      <IconButton
        sx={{ borderRadius: 0 }}
        aria-label="Horizontally Align"
        onClick={() => alignSelectedItems('horizontal', dispatch)}
      >
        <FormatAlignCenterIcon sx={{ transform: 'rotate(-90deg)' }} />
      </IconButton>
    </div>
  </Tooltip>
);

export default connect()(HorizontallyAlign);
